<template>
  <div class="text-center">
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> Selecione os meses </v-card-title>

        <v-card-text>
          <v-col cols="12" sm="12">
            <v-select
              :items="$constants.meses"
              item-text="descricao"
              item-value="id"
              :value="mesesSelecionados"
              @change="selecionarMeses"
              label="Selecione os meses"
              multiple
              small-chips
              solo
              hide-details
            ></v-select>
            <v-btn class="mt-2" :color="botaoTodos.cor" small text @click="alternarTodos">
              <v-icon left small>{{ botaoTodos.icone }}</v-icon>
              {{ botaoTodos.texto }}
            </v-btn>
            <v-expand-transition>
              <div v-if="todosSelecionados" class="pt-3">
                <v-alert type="info" text dense icon="mdi-clock-outline" class="mb-0">
                  Com todos os meses, o PDF pode demorar um pouco para ser gerado.
                </v-alert>
              </div>
            </v-expand-transition>
          </v-col>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="text" @click="$emit('dialogChange', false)"> Fechar </v-btn>
          <v-btn color="primary" text :disabled="!podeGerar" @click="tipoDiario"> Gerar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    gestao_id: {
      type: [Number, String],
      required: true,
    },
    tipo_diario: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      mesesSelecionados: [],
    };
  },
  computed: {
    todosSelecionados() {
      return this.mesesSelecionados.length === this.$constants.meses.length;
    },
    botaoTodos() {
      return this.todosSelecionados
        ? {
            texto: "Desmarcar todos",
            icone: "mdi-checkbox-multiple-blank-outline",
            cor: "grey darken-1",
          }
        : {
            texto: "Selecionar todos",
            icone: "mdi-checkbox-multiple-marked-outline",
            cor: "primary",
          };
    },
    podeGerar() {
      return this.mesesSelecionados.length > 0;
    },
  },
  methods: {
    selecionarMeses(meses) {
      this.mesesSelecionados = [...meses].sort((a, b) => a - b);
    },
    alternarTodos() {
      this.selecionarMeses(
        this.todosSelecionados ? [] : this.$constants.meses.map((mes) => mes.id)
      );
    },
    async tipoDiario() {
      if (this.tipo_diario === 1) {
        this.diarioFrequencia();
      }
      if (this.tipo_diario === 2) {
        this.diarioAulas();
      }
      if (this.tipo_diario === 3) {
        this.diarioFrequenciaComplementar();
      }
      if (this.tipo_diario === 4) {
        this.diarioAulasComplementares();
      }
    },
    async diarioFrequencia() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.diarioFrequencia(
          this.gestao_id,
          this.mesesSelecionados
        );
        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async diarioFrequenciaComplementar() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.diarioFrequenciaComplementar(
          this.gestao_id,
          this.mesesSelecionados
        );
        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async diarioAulas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.diarioAulas(this.gestao_id, this.mesesSelecionados);
        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async diarioAulasComplementares() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.diarioAulasComplementares(
          this.gestao_id,
          this.mesesSelecionados
        );
        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style lang="scss" scoped></style>
